
export default {
  name: 'RelatedBusinessCell',
  props: {
    type: {
      type: String,
      default: ''
    },
    cellIndex: Number,
    data: Object,
    showFoot: {
      type: Boolean,
      default: true
    },
    cursorPointer: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {};
  },
  // 相关CRM等类型展示布局
  computed: {
    typeName: function typeName() {
      if (this.type == 'customer') {
        return '客户';
      } else if (this.type == 'contacts') {
        return '联系人';
      } else if (this.type == 'business') {
        return '商机';
      } else if (this.type == 'contract') {
        return '合同';
      }
      return '';
    },
    name: function name() {
      return this.data.name || this.data.business_name || this.data.customer_name || this.data.number;
    }
  },
  watch: {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},

  methods: {
    footClick: function footClick() {
      this.$emit('unbind', this.type, this.cellIndex, this.data);
    },
    bodyClick: function bodyClick() {
      this.$emit('detail', this.type, this.cellIndex, this.data);
    }
  }
};